<template>
  <!-- The homepage hero (docs/blocks-redesign.md §4.2): the entry has no title, so the abstract is the H1 -->
  <hero-media
    :class="{ '-has-abstract': data.abstract }"
    :link="data.link"
    :form-link="data.formLink"
    :image-desktop="data.imageDesktop"
    :image-mobile="data.imageMobile"
    :video="data.video">
    <h1
      v-if="data.abstract"
      class="hp-hero__abstract">
      {{ data.abstract }}
    </h1>

    <template #aside>
      <div
        v-if="news"
        class="hp-hero__card -is-desktop">
        <news-badge
          :initiative="news?.handle == 'initiatives'"
          :title="news?.title"
          :category="exists(news.category) ? getFirst(news.category) : null"
          :slug="news?.slug" />
      </div>
    </template>
  </hero-media>
</template>

<script setup>
  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  })

  const news = computed(() => exists(props.data.news) ? getFirst(props.data.news) : null)
</script>

<style lang="scss" scoped>
  .hp-hero__abstract {
    @include body-m;

    text-transform: uppercase;
    font-weight: normal;
    margin-bottom: rem(16px);
  }

  .hp-hero__card {
    position: relative;
    z-index: 2;
    grid-row: 2 / span 1;
    align-self: flex-start;
  }

  .hp-hero__card .news-badge {
    width: auto;
    justify-self: flex-end;
  }

  .-has-abstract .hp-hero__card .news-badge {
    transform: none;
  }
</style>
